import { equal } from "./equal";
import { equalSchema } from "./equal-schema";
import { murmur3 } from "./murmur";
import { deserialize, serialize } from "./serialize";
import { sha256 } from "./sha256";
import { parse, stringify } from "./stringify";

export const canon = {
  equal,
  equalSchema,
  serialize,
  deserialize,
  sha256,
  stringify,
  parse,
  murmur3,
};

export type { SerializableValue, SerializeResult, serializableValueSchema } from "./serialize";
